import React from 'react'
import * as momentTimezone from 'moment-timezone'
import { Select } from 'components/form'

const TimezoneSelect = ({setTimezone, value, ...props}) => {
    const avaliableTimezones = momentTimezone.tz.names()
    const timezonesObjects = avaliableTimezones.map(timezone => ({label: timezone, value: timezone}))


    return <Select searchable options={timezonesObjects} value={value} onChange={(v) => setTimezone(v)} placeholder="Select a timezone" {...props} />
}

export default TimezoneSelect